module.exports = "/assets/data/6ee52b701bec175d6143c954d4b69d8b-W6.data.json";